// extracted by mini-css-extract-plugin
module.exports = {"content":"SubscribeForm_content__8t6G2","rule":"SubscribeForm_rule__E8i0W","rule_i":"SubscribeForm_rule_i__3oIaY"};